export default __webpack_public_path__ + "static/media/opensea-circle.a1300415.svg";